import {PiTrashBold} from "react-icons/pi";

export const contextTypes = [
	{
		type: "employees",
		name: "Employees",
	},
	{
		type: "service_providers",
		name: "Service Providers",
	},
	{
		type: "volunteers",
		name: "Volunteers",
	},
	{
		type: "partners_all",
		name: "All Partners",
	},
	{
		type: "partner_members",
		name: "Partner Members",
	},
	{
		type: "experts",
		name: "Experts",
	},
	{type: "projects", name: "Projects"},
	{
		type: "budget_lines",
		name: "Budget Lines",
	},
	{type: "ngo_budget", name: "NGO Budget"},
	{
		type: "involvements",
		name: "Involvements",
	},
	{
		type: "busy_totals",
		name: "Busy Totals",
	},
	{
		type: "rating",
		name: "Rating",
	},
];
